import { Result } from '@blade/std-lib'
import { PlatformUtil } from '@root/shared'

import * as AppVersion from '../model/app-version'

import type { PlatformUpdate } from '@root/shared'

export const downloadUpdate = async (
  update: PlatformUpdate,
  options: {
    onStarted: (payload: { contentLength?: number | undefined }) => void
    onProgress: (payload: { chunkLength: number }) => void
    onFinished: () => void
  },
): Promise<Result.Result<void, unknown>> => {
  return update.download(options)
}

export const relaunchApplication = PlatformUtil.relaunch

export const getAppVersion = async (): Promise<
  Result.Result<AppVersion.AppVersion, unknown>
> => {
  try {
    const version = await PlatformUtil.getVersion()
    return Result.succeed(new AppVersion.Version({ version }))
  } catch (error) {
    return Result.fail(error)
  }
}
